import styled from 'vue-styled-components'

const animateProps = { isVisible: Boolean, targetHeight: Number  }

const animateWrapper = styled('div', animateProps)`
    height: auto;
    overflow: hidden;
    transition: max-height 0.5s linear;
    max-height: ${props => props.isVisible ? props.targetHeight + 'px' : '0px'}
`

export default animateWrapper
